import React from 'react';
import { getProductForNumber } from '../../selectors';
import { getRouteParam } from '../../utils/routes';
import { getTranslateByScope } from '../../i18n';
import { ImagesAndDescriptions } from './ImagesAndDescriptions';

import {
  ColumnFlexBox,
  Container,
  GoBackRouteButton,
  SpacingBox,
} from '../../Components';
import AppContext from '../../AppContext';
import { ProductToOrderBox } from './ProductToOrderBox';
import { ProductPresenter } from '../../presenters';

const translate = getTranslateByScope('app.productDetail');

const ProductDetail = (props) => {
  const number = getRouteParam(props, 'id');

  return (
    <AppContext.Consumer>
      {(context) => {
        const marketing = !!context.state.marketing;
        const p = getProductForNumber(context)(number);
        if (!p) return null;

        const product = ProductPresenter(p);

        return (
          <div className="margin-10p">
          <ColumnFlexBox>
            <Container>
              <SpacingBox marginTop="lg" marginBottom="lg">
                { !marketing && <GoBackRouteButton text={translate('backToList')} /> }
              </SpacingBox>
              <div className="row">
                <div className="col-12 col-lg-8">
                  <ImagesAndDescriptions product={product} />
                </div>
                <div className="col-12 col-lg-4">
                  <ProductToOrderBox product={product} />
                </div>
              </div>
            </Container>
          </ColumnFlexBox>
          </div>
        );
      }}
    </AppContext.Consumer>
  );
};

export default ProductDetail;
